import React from 'react';
import { LabelService } from '@shared/services/LabelService';

interface TekPointDataDisplayProps {
    point: any;
    className?: string;
}

export const TekPointDataDisplay = ({ point, className = '' }: TekPointDataDisplayProps) => {
    if (!point) return null;

    const data = LabelService.getTekPointData(point);

    return (
        <div className={`json-pairs ${className}`}>
            {data.tt && <div style={{ whiteSpace: 'nowrap' }}>Tutkimustapa: {data.tt}</div>}
            {data.om && <div style={{ whiteSpace: 'nowrap' }}>Omistaja: {data.om}</div>}
            {data.pvm && <div style={{ whiteSpace: 'nowrap' }}>Päiväys: {data.pvm}</div>}
            {data.at && <div style={{ whiteSpace: 'nowrap' }}>Aloitustaso: {data.at}</div>}
            {data.ps && <div style={{ whiteSpace: 'nowrap' }}>Päättymissyvyys: {data.ps}</div>}
            {data.pt && <div style={{ whiteSpace: 'nowrap' }}>Päättymistapa: {data.pt}</div>}
            {data.to && <div style={{ whiteSpace: 'nowrap' }}>Tutkimusorganisaatio: {data.to}</div>}

            {data.numericData.length > 0 && (
                <>
                    <div style={{ whiteSpace: 'nowrap' }}>Data:</div>
                    {data.tx && <div style={{ whiteSpace: 'pre-wrap', textIndent: '-20px', paddingLeft: '20px', paddingRight: '20px' }}>&nbsp;&nbsp;&nbsp;&nbsp;{data.tx}</div>}
                    {data.hm && <div style={{ whiteSpace: 'pre-wrap', textIndent: '-20px', paddingLeft: '20px', paddingRight: '20px' }}>&nbsp;&nbsp;&nbsp;&nbsp;{data.hm}</div>}
                    {data.al && <div style={{ whiteSpace: 'nowrap' }}>&nbsp;&nbsp;&nbsp;&nbsp;{data.al}</div>}
                    {data.numericData.map(item => (
                        <div key={item.key} style={{ whiteSpace: 'nowrap' }}>
                            &nbsp;&nbsp;&nbsp;&nbsp;{item.value}
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};
